import api from "./apiService";

export const getCities = (data) => api().post(`/admin/getCities`, data).then(response => response); 

export const addCity = (data) => api().post(`/admin/addCity`, data).then(response => response); 

export const updateCity = (id, data) => api().put(`/admin/updateCity/${id}`, data).then(response => response); 

export const removeCity = (id) => api().delete(`/admin/removeCity/${id}`).then(response => response); 

export const updateCityStatus = (id, data) => api().put(`/admin/updateCityStatus/${id}`, data).then(response => response); 

export const getCitiesFilter = () => api().get(`/admin/getCitiesFilter`).then(response => response); 

const services = {
    getCities,
    addCity,
    updateCity,
    updateCityStatus,
    removeCity,
    getCitiesFilter
}


export default services;